import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { getHotArticles } from "@/mocks/articles";

export default function HotArticles() {
  const hotArticles = getHotArticles();
  const featured = hotArticles.slice(0, 3);
  const more = hotArticles.slice(3, 7);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              🔥 热门八卦
            </h2>
            <span className="text-xs px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
              实时热搜
            </span>
          </div>
          <Link
            to="/category/star-gossip"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 →
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        {more.length > 0 && (
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {more.map((article) => (
              <ArticleCard key={article.id} article={article} variant="horizontal" />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}